import { CommentRootUuid, parseComment } from '../../models/Comment'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type UpdateCommentArguments = {
  commentUuid: string
  title?: string | null
  text: string
} & CommentRootUuid

export default function useUpdateComment() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: UpdateCommentArguments) => {
      const payload = {
        title: data.title,
        text: data.text,
      }

      const res =
        'groupUuid' in data
          ? await api.put(
              `group/${encodeURIComponent(data.groupUuid)}/comment/${encodeURIComponent(data.commentUuid)}`,
              payload
            )
          : await api.put(
              `course/${encodeURIComponent(data.learningItemUuid)}/comment/${encodeURIComponent(data.commentUuid)}`,
              payload
            )

      await invalidate.comments()

      return parseComment(res)
    },
  })
}
